import { Box } from "@mui/material";
import TableHeader from "../../components/table/TableHeader";
import { MainPadding } from "../../styles/Main.styles";
import { InputRangeDate } from "../../components/input/input";
import { useState, useCallback } from "react";
import {
  useGetIncomeSummary,
  useGetPurchaseExpenseSummary,
  useGetExpenseSummary,
} from "../../api/resolver";
import { ToMoneyFormat } from "../../utils/Helper";
import { useGenerateSummary } from "../invoice/hooks/pdf/GenerateInvoice";
import { LoadingButton } from "../../components/button/Button";

export default function ReportSummary() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { data: dataRawIncomeSummary, isLoading: loadingIncomeSummary } =
    useGetIncomeSummary({ start_date: startDate, end_date: endDate });
  const dataIncomeSummary = dataRawIncomeSummary?.data.data;
  const {
    data: dataRawPurchaseExpenseSummary,
    isLoading: loadingPurchseExpenseSummary,
  } = useGetPurchaseExpenseSummary({
    start_date: startDate,
    end_date: endDate,
  });
  const dataPurchaseExpenseSummary = dataRawPurchaseExpenseSummary?.data.data;
  const { data: dataRawExpenseSummary, isLoading: loadingExpnese } =
    useGetExpenseSummary({
      start_date: startDate,
      end_date: endDate,
    });
  const dataExpenseSummary = dataRawExpenseSummary?.data.data;
  const isFetchSummary =
    loadingExpnese || loadingIncomeSummary || loadingPurchseExpenseSummary;
  const { isLoading: loadingGenerateSummary, generate: generateSummary } =
    useGenerateSummary();
  const summaryData = useCallback(() => {
    const expense: { name: string; total: string }[] = [];
    const income: { name: string; total: string }[] = [];
    let totalExpnse = 0;
    let totalIncome = 0;

    // Expense
    dataExpenseSummary?.forEach((item) => {
      expense.push({
        name: item.name || "-",
        total: item.total_expense.toString(),
      });
      totalExpnse += item.total_expense;
    });
    // Purchase Expense
    dataPurchaseExpenseSummary?.forEach((item) => {
      expense.push({
        name: item.product_type || "-",
        total: item.total_sum.toString(),
      });
      totalExpnse += item.total_sum;
      if (item.tax_sum) {
        expense.push({
          name: `PPN-${item.product_type || "-"}`,
          total: item.tax_sum.toString(),
        });
        totalExpnse += item.tax_sum;
      }
    });
    // Income
    dataIncomeSummary?.forEach((item) => {
      income.push({
        name: item.product_type || "-",
        total: item.total_sum.toString(),
      });
      totalIncome += item.total_sum;
      if (item.tax_sum) {
        income.push({
          name: `PPN-${item.product_type || "-"}`,
          total: item.tax_sum.toString(),
        });
        totalIncome += item.tax_sum;
      }
    });

    return {
      expense: expense,
      income: income,
      totalExpense: ToMoneyFormat(Math.round(totalExpnse)),
      totalIncome: ToMoneyFormat(Math.round(totalIncome)),
      savedTotal: ToMoneyFormat(
        Math.round(totalIncome) - Math.round(totalExpnse)
      ),
    };
  }, [dataPurchaseExpenseSummary, dataExpenseSummary, dataIncomeSummary]);

  const handleGenerateSummary = () => {
    if (!isFetchSummary) {
      generateSummary(summaryData());
    }
  };

  return (
    <MainPadding>
      <TableHeader
        title="Summary Report"
        renderFilter={
          <Box width={"100%"}>
            <InputRangeDate
              startDate={startDate}
              endDate={endDate}
              onChange={(s, e) => {
                setStartDate(s);
                setEndDate(e);
              }}
            />
            <Box mt={2}>
              <LoadingButton
                text="Generate Report"
                onClick={handleGenerateSummary}
                color="secondary"
                variant="contained"
                isLoading={isFetchSummary || loadingGenerateSummary}
              />
            </Box>
          </Box>
        }
      />
    </MainPadding>
  );
}
